module.exports = {"520602001":"市中街道","520602002":"环北街道","520602003":"河西街道","520602005":"灯塔街道","520602006":"川硐街道","520602101":"坝黄镇","520602102":"云场坪镇","520602103":"漾头镇","520602200":"桐木坪侗族乡","520602201":"滑石侗族苗族土家族乡","520602202":"和平土家族侗族乡","520602203":"瓦屋侗族乡","520602204":"六龙山侗族土家族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520602.json
// module id = 2491
// module chunks = 0